import { createSlice } from '@reduxjs/toolkit';

// Load auth data from localStorage
const loadAuthData = () => {
  try {
    const authData = localStorage.getItem('authData');
    if (authData) {
      const { user, token } = JSON.parse(authData);
      return { isLogin: true, currentUser: user, token };
    }
  } catch (error) {
    console.error('Failed to load auth data:', error);
  }
  return { isLogin: false, currentUser: {}, token: null };
};

const initialState = loadAuthData();

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCurrentUser(state, action) {
      const { user, token } = action.payload;
      // Map userType to role for menu filtering
      const userWithRole = {
        ...user,
        role: user.userType || user.role,
      };
      state.currentUser = userWithRole;
      state.token = token;
      state.isLogin = true;

      // Persist to localStorage
      localStorage.setItem('authData', JSON.stringify({ user: userWithRole, token }));
    },
    logout(state) {
      state.currentUser = {};
      state.token = null;
      state.isLogin = false;

      // Clear localStorage
      localStorage.removeItem('authData');
    },
  },
});

export const { setCurrentUser, logout } = authSlice.actions;
const authReducer = authSlice.reducer;

export default authReducer;
